/**
 * Q宫格定位信息
 */
/* eslint-disable */
import {
  saveStorge,
  localKeys
} from './q_business'
import qFetch from './qFetch'

const hysdk = window.hysdk
// 曼谷 ：13.82031   100.66471
// 东京 ：35.672511 139.75842
// 河内 ：21.033333 105.85
const _getPosition = () => {
  return new Promise((resolve, reject) => {
    hysdk.getLocation({
      type: 'wgs84',
      timeout: 4000, // 非必填。当定位时间超出此限制时，调用失败回调。单位：ms
      maximumAge: 60 * 1000 * 1, //定位有效时长 1分钟
      success: (res) => {
        if (!res) return reject('EmptyLocation')
        return resolve(res)
      },
      fail: (err) => {
        return reject(err)
      }
    })
  })
}

const _queryAddress = (position, cbk) => {
  if (!position) return
  const {
    type,
    coords
  } = position
  if (!coords) return
  const {
    latitude,
    longitude
  } = coords
  const isBaidu = type === 'baidu';
  const coordtype = isBaidu ? 'BAIDU' : 'GPS';
  let params = {
    coordType: coordtype,
    latitude: `${latitude}`,
    longitude: `${longitude}`
  }
  //传入类型不是百度坐标系时需要转化为百度坐标
  if (!isBaidu) {
    params.retCoordType = 'BAIDU'
  }
  qFetch({
    url: '/tjbnb/app/common/nologin',
    data: params,
    extraParam: {
      u: '/city/geocoder'
    }
  }).then(res => {
    //返回结果里取转化为bd09后的坐标
    const {
      longitude: lng,
      latitude: lat
    } = (isBaidu ? {
      latitude,
      longitude
    } : res.value.data)
    cbk && cbk({
      location: {
        lat,
        lng
      },
      ...res.value.data
    });
  }).catch(err => {
    cbk && cbk(null)
  })
}

const addExtraFunc = (e) => {
  const {
    city,
    district,
    street,
    isOversea,
    cityId,
    lat,
    lng,
    cityPart,
    poiName,
    street_number
  } = e
  const keyword = poiName || district + street + street_number || ''
  e.toCity = () => {
    return {
      cityName: city,
      cityId,
      cityPart,
      isOversea
    }
  }
  e.toCache = () => {
    return {
      searchKey: keyword,
      filter: JSON.stringify([{
        key: 5,
        value: `14_${lng},${lat}`
      }]),
      // 将用户定位属性安放至
      isUserLocation: true
    }
  }
  return e
}

// 通过传入的位置信息，从接口拿到cityId
const getCityModel = (addr) => {
  if (!addr || !addr.cityId) return null
  const {
    cityName,
    district = '',
    street = '',
    streetNumber = '',
    oversea,
    cityId
  } = addr;
  const {
    lat,
    lng
  } = addr.location
  saveStorge(localKeys.LOCATION, {
    lat,
    lng
  })
  let address = {
    lat, // 纬度
    lng, // 经度
    city: cityName,
    district,
    street,
    street_number: streetNumber,
    cityId,
    cityPart: oversea ? 2 : 1,
    isOversea: oversea,
    poiName: `${street || ''}${streetNumber || ''}`
  }
  address = addExtraFunc(address)
  return address;
}

// 通过百度接口重新得到lat&lng
export const fetchPosition = () => {
  return new Promise((resolve, reject) => {
    _getPosition()
      .then((res) => {
        if (!res.coords) {
          reject('EmptyCoords')
          return
        }
        _queryAddress(res, (addr) => {
          if (!addr || !addr.addressComponent) {
            reject('EmptyAddress')
            return
          }
          const {
            lat,
            lng
          } = addr.location
          saveStorge(localKeys.LOCATION, {
            lat,
            lng
          })
          resolve({
            lat,
            lng
          })
        }).catch((err) => {
          reject(err)
        })
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//  完整的城市模型
export const fetchLocation = () => {
  return new Promise((resolve, reject) => {
    _getPosition()
      .then((res) => {
        if (!res.coords) {
          reject('EmptyCoords')
          return
        }
        _queryAddress(res, addr => {
          const model = getCityModel(addr);
          model ? resolve(model) : reject(null);
        })
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default {
  fetchLocation,
  fetchPosition
}